export enum SendState {
  Unsent = 0,
  SendOk = 1,
  SendError = 2,
}
